var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowDesc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-transfer-vertical-1 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00466 2.00473C3.9021 3.10732 3 4.01782 3 4.02804C3 4.03827 3.18376 4.23054 3.40834 4.45529L3.81668 4.86394L4.83557 3.84518L5.85446 2.82642V8.70898V14.5916H6.44601H7.03756V7.29578C7.03756 3.2831 7.03121 0 7.02344 0C7.01568 0 6.10723 0.902122 5.00466 2.00473Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89648 8.70422C8.89648 12.7169 8.90281 16 8.91053 16C8.91827 16 9.83091 15.0937 10.9386 13.986L12.9527 11.972L12.535 11.554L12.1174 11.1361L11.0985 12.1548L10.0796 13.1736V7.29102V1.40845H9.48803H8.89648V8.70422Z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDesc);
export default __webpack_public_path__ + "static/media/icon--arrow-desc.10d3910336c904344ec3af3d3a6a459f.svg";
export { ForwardRef as ReactComponent };